import { DateTime } from 'luxon';
export const getInitialDate = (value, min) => {
    if (value) {
        return value;
    }
    const today = DateTime.now().startOf('day').toJSDate();
    return min > today ? min : today;
};
